import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { forwardRef as b } from "react";
import { ErrorMessage as d } from "../../ErrorMessage/index.js";
import { u as h } from "../../../use-uncontrolled-J2aphITS.js";
import { C as f } from "../../../Checkbox-BSQC8eHj.js";
import '../../../assets/index5.css';const x = "CheckboxGroup-module__container___uEOq9", C = "CheckboxGroup-module__root___r0tTu", k = "CheckboxGroup-module__label___wEJar", o = {
  container: x,
  root: C,
  label: k
}, G = b(({
  label: t,
  orientation: l = "vertical",
  required: e,
  error: r,
  children: s,
  value: n,
  defaultValue: c,
  onChange: m
}, u) => {
  const [_, i] = h({
    value: n,
    defaultValue: c || [],
    onChange: m
  });
  return /* @__PURE__ */ p("div", { className: o.container, children: [
    /* @__PURE__ */ a(
      f.Group,
      {
        label: t,
        value: _,
        onChange: i,
        ref: u,
        classNames: {
          root: o.root,
          label: o.label
        },
        mod: {
          orientation: l,
          required: e
        },
        withAsterisk: e,
        children: s
      }
    ),
    r && /* @__PURE__ */ a(d, { error: r })
  ] });
});
G.displayName = "Checkbox.Group";
export {
  G as Group
};
